module.exports = __webpack_public_path__ + "img/pen-icon.9ff2a704.svg";